import HTTP from './http'
export default HTTP
